export * from './IconBookmarkStroked';
